import styled from "@emotion/styled";
import {PC, Mobile} from "../../../../hooks/util/useMediaquery";

import PayDescriptionPC from "./PC/PayDescription"
import PayDescriptionMobile from "./Mobile/PayDescription";

const Elem:React.FC<any> = () => {
  return (
    <>
      <PC>
        <PayDescriptionPC />
      </PC>

      <Mobile>
        <PayDescriptionMobile />
      </Mobile>
    </>
  )
};

export default Elem;